import { cancelSession } from '@uplift/api';
import { useMutation } from '@tanstack/react-query';

export const useCancelSession = () => {
  const mutation = useMutation(cancelSession);

  return mutation.mutateAsync;
};
